import { Component, OnInit, Output, EventEmitter } from '@angular/core';

import { CPQScreenOption } from '../../../models/CPQUI';
@Component({
  selector: 'app-vert-radio-button',
  templateUrl: './vert-radio-button.component.html',
  styleUrls: ['./vert-radio-button.component.css']
})
export class VertRadioButtonComponent implements OnInit {
  @Output() RadioOnChangeEmitter: EventEmitter<any> = new EventEmitter();
  CurrentScreenOption: CPQScreenOption;
  constructor() { }

  ngOnInit(): void {
  }

  SetControl(control: CPQScreenOption) {

    this.CurrentScreenOption = control;
  }

  onChangeEmitter(val: string) {
    this.CurrentScreenOption.Value = val;
    this.RadioOnChangeEmitter.emit(this.CurrentScreenOption);
  }
}
